
/**
 *  抽象组件类
 * 提供了一些抽象函数生命周期的定义方式。函数的命名的灵(就)感(是)来(抄)自(的)React。
 * 请注意！！！请注意！！！请注意！！！
 * 不要完全的将下面的生命周期函数跟react做类比。它们有相似的地方。但它不是React。
 * 下面生命周期钩子都会详细讲解使用场景作用域。
 *
 * @export
 * @abstract
 * @class Component
 * @template P
 * @template S
 */
export default abstract class Component<P, S> {
  $parent!: JQuery;

  $el!: JQuery;

  props!: P;

  _componentDidMount?: boolean; // @jeact标记生命

  abstract state?: S;

  /**
   * 派生state
   *
   * 此钩子函数在每次render函数执行之前执行。
   *
   * 如果函数返回null。将不会执行render函数渲染模板
   *
   * 如果返回state。将会赋值给this.state
   * @param props 最新的props
   * @param state 上一次的state
   */
  getDerivedStateFromProps?(props: P, state: S): null | S;

  /**
   * 当组件收到新的 props 或 state 时.会在渲染(即render)之前调用componentWillRender.
   * 此函数会在每次render之前都会调用
   * 所以你可以将它类比为React中的 componentWillMount 与 componentWillUpdate 的结合.且你并不能阻止render函数的更新.
   * 你可以在这里根据props或者state的一些数据来执行一些额外的行为.
   */
  componentWillRender?(): void;

  /**
   * 在组件render函数执行完成并挂载至DOM前触发
   *
   * 会在每次render完后立即同步执行。
   */
  componentAfterRender?(): void;

  /**
   * 组件已经挂载。这个是与react一致的。
   */
  componentDidMount?(): void;

  /**
   * 组件已经更新完毕
   */
  componentDidUpdate?(): void;

  /**
   *  模板渲染函数
   *
   *  @description 执行模板渲染。
   */
  abstract render(): void | string;
}



// WEBPACK FOOTER //
// ./src/types/Componet.ts